/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var $window = $(window);
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	// メディアクエリ
	var mql = window.matchMedia('screen and (max-width: 768px)');
	
	// preload
	
	(0, _module.preload)();
	
	// resizing
	
	(0, _module.resizing)();
	
	// resizing
	
	(0, _module.showMovie)();
	//
	// // resizing
	// import {headerPin} from "../include/module";
	// headerPin();
	
	// resizing
	
	(0, _module.headerToggle)();
	
	//ページ内リンクのアニメーション
	
	(0, _module.anchorScroll)();
	
	// import {kv_animation} from "../include/module";
	// $(window).on('load', function(){
	//   setTimeout(function () {
	//     kv_animation();
	//   }, 100);
	// });
	
	$(window).on('load', function () {
	  setTimeout(function () {
	    (0, _module.scrollAnimation)();
	  }, 100);
	});
	$(window).on('scroll', function () {
	  (0, _module.scrollAnimation)();
	});
	
	// ------------------------------------------------------------------------
	// mvPin
	// ------------------------------------------------------------------------
	// const mvPin = () => {
	//   $(window).on("load", function () {
	//     let rate = windowWidth / windowHeight;
	//     if (matchMedia('(min-width: 1301px)').matches && rate > 1.43) {
	//       ScrollTrigger.create({
	//         trigger: '.index-Kv',
	//         pin: '.kv-info',
	//         end: 'bottom bottom',
	//         toggleClass: {
	//           targets: ".kv-info",//ターゲットの要素
	//           className: "scrolled" //付け外しするクラス
	//         },
	//       })
	//     }
	//   });
	//   $(window).on("resize", function () {
	//     ScrollTrigger.refresh();
	//   });
	// };
	// mvPin();
	
	// ------------------------------------------------------------------------
	// kvScroll
	// ------------------------------------------------------------------------
	//kvScroll
	var kvScroll = function kvScroll() {
	  var mq = window.matchMedia('(max-width: 768px)');
	  function checkBreakPoint(mq) {
	    if (mq.matches) {
	      $(window).on('resize scroll', function () {
	        $("#kv-scroll").css({ 'transform': '', 'top': '', 'left': '' });
	        // $("#kv-scroll").removeAttr('style');
	      });
	    } else {
	      $(window).on('ready load resize scroll', function () {
	        var winScroll = $(window).scrollTop();
	        var winHeight = $(window).height();
	        var logoHeight = $('#kv-scroll').height();
	        var logowidth = $('#kv-scroll').width();
	        var logowidthWrapper = $('.index-Kv_Content').width();
	        var logoheightWrapper = $('.index-Kv_Content').height();
	        $("#kv-scroll").css("left", logowidthWrapper * 0.5 - logowidth * 0.52);
	        if (!($('#info').offset().top < winScroll + winHeight)) {
	          $("#kv-scroll").css("top", winHeight / 2 + $(window).scrollTop() - logoHeight * 0.5);
	        } else {
	          //+50はmargin分
	          $("#kv-scroll").css("top", -winHeight / 2 + logoheightWrapper - logoHeight * 0.5 + 50);
	        }
	        if (winHeight < logoHeight) {
	          var resizeLogo = 1 - (logoHeight - winHeight) / logoHeight;
	          $("#kv-scroll").css("transform", 'scale(' + resizeLogo + ')');
	        } else {
	          $("#kv-scroll").css("transform", 'scale(1)');
	        }
	      });
	    }
	  };
	  mq.addListener(checkBreakPoint);
	  checkBreakPoint(mq);
	};
	kvScroll();
	
	/*-------------------------------------------------------------------*/
	/* kv_modal */
	/*-------------------------------------------------------------------*/
	var kv_modal = function kv_modal() {
	  $('.kv-modal').on('click', function () {
	    $(this).css({ 'opacity': '1' }).stop().animate({ 'opacity': '0' }, 300, 'easeOutQuart', function () {
	      $(this).css({ 'display': 'none' });
	    });
	  });
	  //  $('.kv-modal .kv-modal_Close').on('click', function () {
	  //    $('.kv-modal').css({ 'opacity': '1' }).stop().animate({ 'opacity': '0' }, 300, 'easeOutQuart', function () {
	  //      $('.kv-modal').css({ 'display': 'none' });
	  //    });
	  //  });
	};
	kv_modal();
	/*-------------------------------------------------------------------*/
	/* kv_scroll */
	/*-------------------------------------------------------------------*/
	var kv_scroll = function kv_scroll() {
	  $(window).on("load", function () {
	    var firstPosition = $(window).scrollTop();
	    if (firstPosition >= 50) {
	      $(".index-Kv .scroll").addClass('scrolled');
	    }
	  });
	  $(window).on("scroll", function () {
	    var scrollPosition = $(window).scrollTop();
	    if (scrollPosition >= 50) {
	      $(".index-Kv .scroll").addClass('scrolled');
	    } else {
	      $(".index-Kv .scroll").removeClass('scrolled');
	    }
	  });
	};
	kv_scroll();
	
	// ------------------------------------------------------------------------
	// pickup
	// ------------------------------------------------------------------------
	var pickup = new Swiper('.pickup_List', {
	  // Optional parameters
	  direction: 'horizontal',
	  loop: true,
	  slidesPerView: 1,
	  loopAdditionalSlides: 1,
	  breakpoints: {
	    769: {
	      // loop: false,
	      slidesPerView: 3
	    }
	  },
	  // If we need pagination
	  pagination: {
	    el: '.pickup-pagination',
	    clickable: true
	  },
	  navigation: { //ナビゲーションのオプション（矢印ボタンの要素を指定）
	    nextEl: '.pickup-button-next',
	    prevEl: '.pickup-button-prev'
	  }
	});
	var movie = new Swiper('.movie_List', {
	  // Optional parameters
	  direction: 'horizontal',
	  loop: true,
	  slidesPerView: 1,
	  loopAdditionalSlides: 1,
	  // If we need pagination
	  pagination: {
	    el: '.movie-pagination',
	    clickable: true
	  },
	  navigation: { //ナビゲーションのオプション（矢印ボタンの要素を指定）
	    nextEl: '.movie-button-next',
	    prevEl: '.movie-button-prev'
	  }
	});
	
	/*-------------------------------------------------------------------*/
	/* 3点リーダー */
	/*-------------------------------------------------------------------*/
	var cutText = function cutText() {
	  $(window).on('load', function () {
	    $('.ellipsis p').trunk8({
	      fill: '…',
	      lines: 2
	    });
	    if (mql.matches) {
	      $('.ellipsis p').trunk8({
	        lines: 3
	      });
	    }
	  });
	
	  var timer = 0;
	  $(window).on('resize', function () {
	    if (timer > 0) {
	      clearTimeout(timer);
	    }
	    timer = setTimeout(function () {
	      windowWidth = $window.width();
	      $('.ellipsis p').trunk8({
	        fill: '…',
	        lines: 2
	      });
	      if (mql.matches) {
	        $('.ellipsis p').trunk8({
	          lines: 3
	        });
	      }
	    }, 100);
	  });
	};
	cutText();
	
	// //テキストのカウントアップの設定
	// var bar = new ProgressBar.Line(loading_Text, {//id名を指定
	// 	strokeWidth: 0,//進捗ゲージの太さ
	// 	duration: 2000,//時間指定(1000＝1秒)
	// 	trailWidth: 0,//線の太さ
	// 	text: {//テキストの形状を直接指定
	// 		style: {
	// 			position:'absolute',
	// 			left:'50%',
	// 			top:'50%',
	// 			margin:'0',
	// 			transform:'translate(-50%,-50%)',
	// 			// 'font-family':'sans-serif',
	// 			// 'font-size':'1.5rem',
	// 			color:'#2dffd2',
	// 		},
	// 		autoStyleContainer: false //自動付与のスタイルを切る
	// 	},
	// 	step: function(state, bar) {
	// 		bar.setText(Math.round(bar.value() * 100) + ' %'); //テキストの数値
	// 	}
	// });
	// //アニメーションスタート
	// bar.animate(1.0, function () {//バーを描画する割合を指定します 1.0 なら100%まで描画
	// 	$("#loading").delay(500).fadeOut(800);//アニメーションが終わったら#loadingをフェードアウト
	// });
	
	
	var loading_anime = function loading_anime() {
	  var images = $('img'); // ページ内の画像取得
	  var percent = $('#loading_Text'); // パーセントのテキスト部分
	  var loading = $('#loading'); // ローディング要素
	  var imgCount = 0;
	  var baseCount = 0;
	  var current;
	
	  // 画像の読み込み
	  for (var i = 0; i < images.length; i++) {
	    var img = new Image(); // 画像の作成
	    // 画像読み込み完了したとき
	    img.onload = function () {
	      imgCount += 1;
	    };
	    // 画像読み込み失敗したとき
	    img.onerror = function () {
	      imgCount += 1;
	    };
	    img.src = images[i].src; // 画像にsrcを指定して読み込み開始
	  };
	
	  // ローディング処理
	  var nowLoading = setInterval(function () {
	    if (baseCount <= imgCount) {
	      // baseCountがimgCountを追い抜かないようにする
	      // 現在の読み込み具合のパーセントを取得
	      baseCount += 1;
	      current = Math.floor(baseCount / images.length * 100);
	      // パーセント表示の書き換え
	      percent.html(current + '%');
	      // 全て読み込んだ時
	      if (baseCount == images.length) {
	        // ローディングの終了
	        loading.addClass('loaded');
	        loading.delay(500).fadeOut(1000);
	        clearInterval(nowLoading);
	      }
	    }
	  }, 80);
	};
	// $(window).on('ready', function() {
	//   setTimeout(function () {
	//     loading_anime();
	//   }, 600);
	// });
	var keyName = 'visited';
	var keyValue = true;
	$('body').removeClass('preload');
	if (!sessionStorage.getItem(keyName)) {
	  //sessionStorageにキーと値を追加
	  sessionStorage.setItem(keyName, keyValue);
	  //ここに初回アクセス時の処理
	  $(window).on('ready', function () {
	    setTimeout(function () {
	      loading_anime();
	    }, 800);
	  });
	} else {
	  $('#loading').css('display', 'none');
	}

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $window = $(window);
	var breakPoint = 768;
	
	var resizeFlag = false;
	var windowWidth = $window.width();
	var windowHeight = $window.height();
	//const bodyLimitHeight = (windowHeight - 185) * 0.88;
	
	var url = location.href;
	
	// preload
	var preload = function preload() {
	  var timer = 0;
	  $(window).on('load', function () {
	    if (timer > 0) {
	      clearTimeout(timer);
	    }
	    timer = setTimeout(function () {
	      $("body").removeClass("preload");
	    }, 100);
	  });
	};
	
	// resizing
	var resizing = function resizing() {
	  var timer = 0;
	  $(window).on('resize', function () {
	    var resizeWidth = $window.width();
	    if (windowWidth !== resizeWidth) {
	      $("body").addClass("resizing");
	      if (timer > 0) {
	        clearTimeout(timer);
	      }
	      timer = setTimeout(function () {
	        $("body").removeClass("resizing");
	      }, 100);
	    }
	    windowWidth = resizeWidth;
	  });
	};
	
	//ページ内リンクのアニメーション
	var anchorScroll = function anchorScroll() {
	  var $anchor = $('a[href^=#]');
	  $anchor.click(function () {
	    var speed = 1000;
	    var href = $(this).attr('href');
	    var target = $(href == '#' || href == '' ? 'html' : href);
	    var position = target.offset().top;
	    $('html, body').animate({
	      scrollTop: position
	    }, speed, 'swing');
	    return false;
	  });
	};
	
	// ------------------------------------------------------------------------
	// headerPin
	// ------------------------------------------------------------------------
	var headerPin = function headerPin() {
	  $(window).on("load", function () {
	    var rate = windowWidth / windowHeight;
	    if (matchMedia('(min-width: 769px)').matches && rate > 1.43) {
	      // if (matchMedia('(min-width: 1301px)').matches && rate > 1.43) {
	      ScrollTrigger.create({
	        trigger: '.st-Header',
	        pin: '.st-Header_Bar',
	        end: 'bottom bottom'
	      });
	    }
	  });
	};
	
	// // ------------------------------------------------------------------------
	// // kv_animation
	// // ------------------------------------------------------------------------
	// const kv_animation = () => {
	//   let winScroll = $(window).scrollTop();
	//   let winHeight = $(window).height();
	//   // js-Animation
	//   $('.js-Animation-kv').each(function(){
	//     let target = $(this);
	//     target.addClass('animated');
	//   });
	// };
	
	// ------------------------------------------------------------------------
	// js-Animation
	// ------------------------------------------------------------------------
	var scrollAnimation = function scrollAnimation() {
	  var winScroll = $(window).scrollTop();
	  var winHeight = $(window).height();
	  // js-Animation
	  $('.js-Animation').each(function () {
	    var target = $(this);
	    if (target.offset().top < winScroll + winHeight * .9) {
	      target.addClass('animated');
	    }
	  });
	};
	
	/*-------------------------------------------------------------------*/
	/* movieモーダル */
	/*-------------------------------------------------------------------*/
	// movie
	var showMovie = function showMovie() {
	  var $modal = $('#movie-Stage');
	  var $content = $('#movie-Iframe');
	
	  // open
	  $('body').on('click', '.js-Youtube', function () {
	
	    var dataID = $(this).attr('data-youtube');
	
	    $('#movie-Stage').css({ 'opacity': '0', 'display': 'block' }).stop().animate({ 'opacity': '1', 'width': 100 + '%', 'height': 100 + 'vh', 'top': 0, 'left': 0 }, 300, 'easeOutQuart', function () {
	      //iframe append
	      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
	      // // fadeIn
	      // $modal.stop().fadeIn(400);
	      return false;
	    });
	  });
	
	  //close
	  $('#movie-Close,#movie-Iframe').on('click', function () {
	
	    $('#movie-Stage').css({ 'opacity': '1' }).stop().animate({ 'opacity': '0' }, 300, 'easeOutQuart', function () {
	      $('#movie-Stage').css({ 'display': 'none' });
	      $content.children('iframe').remove();
	    });
	  });
	};
	
	// ------------------------------------------------------------------------
	// headerToggle
	// ------------------------------------------------------------------------
	var headerToggle = function headerToggle() {
	  var $header = $('.st-Header');
	  // const $header_btn = $('.st-Header .st-Header_Hamburger');
	  var $header_btn = $('.st-Header .st-Header_Menu');
	  var $header_link = $('.st-Header a[href^=#]');
	  // const $header_link = $('.st-Header a[href^="#"]');
	  $header_btn.on('click', function () {
	    $header.toggleClass('active');
	    // $('body').toggleClass('noscrollBar');
	  });
	  $header_link.click(function () {
	    $header.removeClass('active');
	    // $('body').removeClass('noscrollBar');
	    return false;
	  });
	};
	
	//export
	exports.preload = preload;
	exports.resizing = resizing;
	exports.anchorScroll = anchorScroll;
	exports.scrollAnimation = scrollAnimation;
	exports.showMovie = showMovie;
	exports.headerPin = headerPin;
	exports.headerToggle = headerToggle;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js